/**
 * Country dial codes for the phone entry step of registration.
 *
 * Ordered with the server's primary allowlist regions first (US, CA,
 * MX) so the default dropdown state matches config/sms.php's default
 * SMS_ALLOWED_COUNTRY_CODES=+1. Server-side allowlist is the real gate
 * - including a country here just lets the UI offer it; the server
 * will still 422 if the dial code is outside the configured list.
 *
 * Flag emoji render is the Unicode Regional Indicator Symbol pair for
 * the ISO 3166-1 alpha-2 code. They render correctly in modern browsers
 * on desktop and mobile; no PNG assets or webfont required.
 */
export const COUNTRY_PHONE_CODES = [
    {iso: "US", label: "United States", flag: "\uD83C\uDDFA\uD83C\uDDF8", dial: "+1"},
    {iso: "CA", label: "Canada", flag: "\uD83C\uDDE8\uD83C\uDDE6", dial: "+1"},
    {iso: "MX", label: "Mexico", flag: "\uD83C\uDDF2\uD83C\uDDFD", dial: "+52"},
    {iso: "GB", label: "United Kingdom", flag: "\uD83C\uDDEC\uD83C\uDDE7", dial: "+44"},
    {iso: "IE", label: "Ireland", flag: "\uD83C\uDDEE\uD83C\uDDEA", dial: "+353"},
    {iso: "AU", label: "Australia", flag: "\uD83C\uDDE6\uD83C\uDDFA", dial: "+61"},
    {iso: "NZ", label: "New Zealand", flag: "\uD83C\uDDF3\uD83C\uDDFF", dial: "+64"},
    {iso: "DE", label: "Germany", flag: "\uD83C\uDDE9\uD83C\uDDEA", dial: "+49"},
    {iso: "FR", label: "France", flag: "\uD83C\uDDEB\uD83C\uDDF7", dial: "+33"},
    {iso: "ES", label: "Spain", flag: "\uD83C\uDDEA\uD83C\uDDF8", dial: "+34"},
    {iso: "IT", label: "Italy", flag: "\uD83C\uDDEE\uD83C\uDDF9", dial: "+39"},
    {iso: "NL", label: "Netherlands", flag: "\uD83C\uDDF3\uD83C\uDDF1", dial: "+31"},
    {iso: "SE", label: "Sweden", flag: "\uD83C\uDDF8\uD83C\uDDEA", dial: "+46"},
    {iso: "NO", label: "Norway", flag: "\uD83C\uDDF3\uD83C\uDDF4", dial: "+47"},
    {iso: "DK", label: "Denmark", flag: "\uD83C\uDDE9\uD83C\uDDF0", dial: "+45"},
    {iso: "FI", label: "Finland", flag: "\uD83C\uDDEB\uD83C\uDDEE", dial: "+358"},
    {iso: "BR", label: "Brazil", flag: "\uD83C\uDDE7\uD83C\uDDF7", dial: "+55"},
    {iso: "AR", label: "Argentina", flag: "\uD83C\uDDE6\uD83C\uDDF7", dial: "+54"},
    {iso: "CL", label: "Chile", flag: "\uD83C\uDDE8\uD83C\uDDF1", dial: "+56"},
    {iso: "CO", label: "Colombia", flag: "\uD83C\uDDE8\uD83C\uDDF4", dial: "+57"},
    {iso: "PE", label: "Peru", flag: "\uD83C\uDDF5\uD83C\uDDEA", dial: "+51"},
    {iso: "IN", label: "India", flag: "\uD83C\uDDEE\uD83C\uDDF3", dial: "+91"},
    {iso: "PH", label: "Philippines", flag: "\uD83C\uDDF5\uD83C\uDDED", dial: "+63"},
    {iso: "ID", label: "Indonesia", flag: "\uD83C\uDDEE\uD83C\uDDE9", dial: "+62"},
    {iso: "JP", label: "Japan", flag: "\uD83C\uDDEF\uD83C\uDDF5", dial: "+81"},
    {iso: "KR", label: "South Korea", flag: "\uD83C\uDDF0\uD83C\uDDF7", dial: "+82"},
    {iso: "SG", label: "Singapore", flag: "\uD83C\uDDF8\uD83C\uDDEC", dial: "+65"},
    {iso: "AE", label: "United Arab Emirates", flag: "\uD83C\uDDE6\uD83C\uDDEA", dial: "+971"},
    {iso: "SA", label: "Saudi Arabia", flag: "\uD83C\uDDF8\uD83C\uDDE6", dial: "+966"},
    {iso: "ZA", label: "South Africa", flag: "\uD83C\uDDFF\uD83C\uDDE6", dial: "+27"},
    {iso: "EG", label: "Egypt", flag: "\uD83C\uDDEA\uD83C\uDDEC", dial: "+20"},
    {iso: "NG", label: "Nigeria", flag: "\uD83C\uDDF3\uD83C\uDDEC", dial: "+234"},
    {iso: "KE", label: "Kenya", flag: "\uD83C\uDDF0\uD83C\uDDEA", dial: "+254"},
];

export const DEFAULT_COUNTRY = COUNTRY_PHONE_CODES[0];
